import { render, staticRenderFns } from "./WorksAList.vue?vue&type=template&id=1b7812f0&scoped=true&"
import script from "./WorksAList.ts?vue&type=script&lang=ts&"
export * from "./WorksAList.ts?vue&type=script&lang=ts&"
import style0 from "./WorksAList.vue?vue&type=style&index=0&id=1b7812f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7812f0",
  null
  
)

export default component.exports